'use client';

import { useState } from 'react';

// Общая клиентская логика email magic-link (EMAIL_AUTH_PLAN.md).
// Переиспользуется формой на /auth, инлайн-формой на лендинге и привязкой
// email в настройках — отличаются только endpoint'ом и оформлением.

export type EmailLoginStatus = 'idle' | 'sending' | 'sent';

export function useEmailLogin(
  endpoint: string = '/api/auth/email',
  extraBody?: Record<string, unknown>,
) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<EmailLoginStatus>('idle');
  const [error, setError] = useState<string | null>(null);
  // Что именно ушло на почту: 'login' — вместо привязки отправлена ссылка
  // входа в уже существующий аккаунт с этим адресом (гость приложения).
  const [sentMode, setSentMode] = useState<string | null>(null);

  async function submit() {
    if (status === 'sending') return;
    setError(null);
    setStatus('sending');
    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, ...extraBody }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(data.error || 'Не удалось отправить письмо');
        setStatus('idle');
        return;
      }
      setSentMode(typeof data.mode === 'string' ? data.mode : null);
      setStatus('sent');
    } catch {
      setError('Нет связи с сервером. Попробуйте ещё раз.');
      setStatus('idle');
    }
  }

  return { email, setEmail, status, error, submit, sentMode };
}
